import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../component/Loadable";
import CustomerPortalGuard, { CustomerPortalGuestGuard } from "../customerPortal/CustomerPortalGuard";
import { CUSTOMER_PORTAL_BASE_PATH, customerPortalPath } from "../customerPortal/constants";

// Keep route matching and guards synchronous; page code and portal styles are
// fetched only after the corresponding route passes its existing guard.
const CustomerPortalLayout = Loadable(lazy(() => import("../customerPortal/CustomerPortalLayout")));
const CustomerPortalLogin = Loadable(lazy(() => import("../customerPortal/pages").then(module => ({ default: module.CustomerPortalLogin }))));
const CustomerPortalRegister = Loadable(lazy(() => import("../customerPortal/pages").then(module => ({ default: module.CustomerPortalRegister }))));
const CustomerPortalForgotPassword = Loadable(lazy(() => import("../customerPortal/pages").then(module => ({ default: module.CustomerPortalForgotPassword }))));
const CustomerPortalDashboard = Loadable(lazy(() => import("../customerPortal/pages/DashboardPage")));
const CustomerPortalAppointments = Loadable(lazy(() => import("../customerPortal/pages/AppointmentsPage")));
const CustomerPortalProfile = Loadable(lazy(() => import("../customerPortal/pages/ProfilePage")));
const CustomerPortalPurchaseHistory = Loadable(lazy(() => import("../customerPortal/pages/PurchaseHistoryPage")));
const CustomerPortalBooking = Loadable(lazy(() => import("../customerPortal/pages/BookingPage")));
const CustomerPortalCheckout = Loadable(lazy(() => import("../customerPortal/pages/CheckoutPage")));
const CustomerPortalWaitlist = Loadable(lazy(() => import("../customerPortal/pages/WaitlistPage")));
const CustomerPortalHandoffPage = Loadable(lazy(() => import("../customerPortal/CustomerPortalHandoffPage")));
const PackagesPage = Loadable(lazy(() => import("../customerPortal/pages/EntitlementsPage").then(module => ({ default: module.PackagesPage }))));
const SubscriptionsPage = Loadable(lazy(() => import("../customerPortal/pages/EntitlementsPage").then(module => ({ default: module.SubscriptionsPage }))));

const CustomerPortalRoutes = {
  path: CUSTOMER_PORTAL_BASE_PATH,
  children: [
    { index: true, element: <Navigate to={customerPortalPath("login")} replace /> },
    { path: "login", element: <CustomerPortalGuestGuard><CustomerPortalLogin /></CustomerPortalGuestGuard> },
    { path: "register", element: <CustomerPortalGuestGuard><CustomerPortalRegister /></CustomerPortalGuestGuard> },
    { path: "forgot-password", element: <CustomerPortalGuestGuard><CustomerPortalForgotPassword /></CustomerPortalGuestGuard> },
    { path: "handoff", element: <CustomerPortalHandoffPage /> },
    {
      element: <CustomerPortalGuard><CustomerPortalLayout /></CustomerPortalGuard>,
      children: [
        { path: "dashboard", element: <CustomerPortalDashboard /> },
        { path: "appointments", element: <CustomerPortalAppointments /> },
        { path: "booking", element: <CustomerPortalBooking /> },
        { path: "checkout", element: <CustomerPortalCheckout /> },
        { path: "profile", element: <CustomerPortalProfile /> },
        { path: "purchase-history", element: <CustomerPortalPurchaseHistory /> },
        { path: "packages", element: <PackagesPage /> },
        { path: "subscriptions", element: <SubscriptionsPage /> },
        { path: "waitlist", element: <CustomerPortalWaitlist /> },
      ],
    },
  ],
};

export { CUSTOMER_PORTAL_BASE_PATH };
export default CustomerPortalRoutes;
